export default "__VITE_ASSET__BgiTtLDp__"